import type { BlogArticle } from '~/types'

export const useBlog = () => {
  const { locale } = useI18n()
  
  const { data: articles, refresh } = useAsyncData<BlogArticle[]>('blog', async () => {
    try {
      // 获取所有文章，包括 .md 和 .en.md 文件
      const allArticles = await queryCollection('blog')
        .where('extension', 'in', ['md', 'en.md'])
        .order('date', 'DESC')
        .all()
        .then(res => res.filter(article => article.path !== '/blog'))
        .catch(error => {
          console.error('Error fetching blog articles:', error)
          return []
        })
      
      if (!allArticles.length) {
        console.warn('No blog articles found')
        return []
      }

      // 根据当前语言（cookie）过滤文章
      const filteredArticles = allArticles.filter(article => {
        const isEnglish = article.path.endsWith('.en')
        const shouldShow = locale.value === 'en' ? isEnglish : !isEnglish
        return shouldShow
      })

      if (!filteredArticles.length) {
        console.warn(`No articles found for locale: ${locale.value}`)
        return []
      }

      // 确保图片路径是完整的
      const processedArticles = filteredArticles.map(article => ({
        ...article,
        image: article.image?.startsWith('http') ? article.image : article.image?.startsWith('/') ? article.image : `/${article.image}`
      }))

      return processedArticles
    } catch (error) {
      console.error('Error in useBlog:', error)
      return []
    }
  }, { 
    default: () => [],
    watch: [locale],
    // 确保在服务器端和客户端都执行
    server: true,
    client: true
  })

  async function fetchList() {
    try {
      if (!articles.value?.length) {
        await refresh()
      }
    } catch (error) {
      console.error('Error fetching blog list:', error)
    }
  }

  return {
    articles,
    // featuredArticle,
    fetchList
  }
}
